/*
 * Colour pack picker — YouPadel grepplindor multipacks (12 / 24 / 50).
 *
 * Renders alongside snippets/colour-pack-picker.liquid. White is the remainder
 * colour: it has no +/- of its own and always holds packSize - sum(others), so
 * the distribution can never be invalid. Keeps the visible line item property
 * `properties[Färger]` in sync, formatted "8× White, 3× Chock Pink, 1× Black"
 * (count descending, then colour name ascending; zero counts omitted).
 *
 * Plain ES5. No build step, no dependencies. Safe to run when no picker is on
 * the page, and re-scans after a Shopify section re-render.
 */
(function () {
  'use strict';

  if (window.cvrColourPackPicker) {
    window.cvrColourPackPicker.schedule();
    return;
  }

  /* Counts survive a section re-render, keyed by product handle. */
  var SAVED = {};

  function fillTemplate(tpl, count, total) {
    return String(tpl).split('[count]').join(count).split('[total]').join(total);
  }

  function byCountThenName(a, b) {
    if (b.count !== a.count) return b.count - a.count;
    if (a.name === b.name) return 0;
    return a.name < b.name ? -1 : 1;
  }

  function Picker(root) {
    this.root = root;
    this.packSize = parseInt(root.getAttribute('data-pack-size'), 10);
    if (isNaN(this.packSize) || this.packSize < 1) this.packSize = 0;
    this.key = root.getAttribute('data-cvr-key') || '';
    this.tpl = root.getAttribute('data-summary-template') || '[count]/[total]';
    this.valueInput = root.querySelector('[data-cvr-colors-value]');
    this.summaryEl = root.querySelector('[data-cvr-colors-summary]');
    this.countEl = root.querySelector('[data-cvr-colors-count]');
    this.baseRow = null;
    this.rows = [];

    var nodes = root.querySelectorAll('[data-cvr-row]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var row = {
        el: node,
        name: node.getAttribute('data-cvr-name') || '',
        isBase: node.getAttribute('data-cvr-base') === 'true',
        countEl: node.querySelector('[data-cvr-count]'),
        minus: node.querySelector('[data-cvr-step="-1"]'),
        plus: node.querySelector('[data-cvr-step="1"]'),
        count: 0
      };
      if (row.isBase && !this.baseRow) this.baseRow = row;
      this.rows.push(row);
    }
  }

  Picker.prototype.restore = function () {
    var saved = this.key ? SAVED[this.key] : null;
    if (!saved) return;
    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];
      if (row.isBase) continue;
      var value = saved[row.name];
      row.count = typeof value === 'number' && value > 0 ? value : 0;
    }
  };

  Picker.prototype.save = function () {
    if (!this.key) return;
    var out = {};
    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];
      if (!row.isBase && row.count > 0) out[row.name] = row.count;
    }
    SAVED[this.key] = out;
  };

  Picker.prototype.render = function () {
    var i, row;

    /* Clamp, newest-last, in case a restored state no longer fits the pack. */
    var used = 0;
    for (i = 0; i < this.rows.length; i++) {
      row = this.rows[i];
      if (row.isBase) continue;
      if (row.count < 0) row.count = 0;
      if (used + row.count > this.packSize) row.count = this.packSize - used;
      if (row.count < 0) row.count = 0;
      used += row.count;
    }

    var base = this.packSize - used;
    if (base < 0) base = 0;
    if (this.baseRow) this.baseRow.count = base;

    var picked = [];
    for (i = 0; i < this.rows.length; i++) {
      row = this.rows[i];
      if (row.countEl) row.countEl.textContent = String(row.count);
      if (row.minus) row.minus.disabled = row.count <= 0;
      if (row.plus) row.plus.disabled = base <= 0;
      if (row.count > 0) picked.push({ name: row.name, count: row.count });
    }

    picked.sort(byCountThenName);
    var parts = [];
    for (i = 0; i < picked.length; i++) {
      parts.push(picked[i].count + '× ' + picked[i].name);
    }
    var value = parts.join(', ');
    var head = fillTemplate(this.tpl, this.packSize, this.packSize);

    if (this.valueInput) this.valueInput.value = value;
    if (this.countEl) this.countEl.textContent = head;
    if (this.summaryEl) this.summaryEl.textContent = value ? head + ' · ' + value : head;

    this.save();
  };

  Picker.prototype.rowFor = function (node) {
    for (var i = 0; i < this.rows.length; i++) {
      var el = this.rows[i].el;
      if (el === node || (el.contains && el.contains(node))) return this.rows[i];
    }
    return null;
  };

  Picker.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var node = event.target;
      var button = null;
      while (node && node !== self.root) {
        if (node.nodeType === 1 && node.getAttribute && node.getAttribute('data-cvr-step') !== null) {
          button = node;
          break;
        }
        node = node.parentNode;
      }
      if (!button || button.disabled) return;
      event.preventDefault();

      var row = self.rowFor(button);
      if (!row || row.isBase) return;

      var step = parseInt(button.getAttribute('data-cvr-step'), 10);
      if (isNaN(step) || step === 0) return;

      var base = self.baseRow ? self.baseRow.count : 0;
      if (step > 0 && base <= 0) return;

      row.count += step;
      if (row.count < 0) row.count = 0;
      self.render();
    });
  };

  function scan() {
    var roots = document.querySelectorAll('[data-cvr-colors]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-cvr-ready') === '1') continue;
      root.setAttribute('data-cvr-ready', '1');
      var picker = new Picker(root);
      if (!picker.packSize || !picker.baseRow) continue;
      picker.restore();
      picker.bind();
      picker.render();
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      scan();
    }, 0);
  }

  window.cvrColourPackPicker = { scan: scan, schedule: schedule };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Shopify theme editor and the Section Rendering API both replace markup. */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);

  if (window.MutationObserver) {
    try {
      new window.MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (error) {
      /* Observing is an optimisation; the picker still works without it. */
    }
  }
})();
